<template lang="pug">
.login
  .frow
    .box
      h1.title-call-out Login
      .frow.column-center
        form
          p.control
            input(v-model="email" type="text" placeholder="Email")
            input(v-model="password" type="password" placeholder="Password")
        VButton(
          text="Login"
          @click.native="login"
        )
        h5 Dont have an account?&nbsp;
          router-link.clr-primary(to="register") Signup
        h5 Forgot your password?&nbsp;
          router-link.clr-primary(to="request-password-reset") Reset password
</template>
<script>
export default {
  name: "login",
  data: () => ({
    email: "",
    password: ""
  }),
  computed: {
    count() {
      return this.$store.getters.isLoggedIn;
    }
  },
  methods: {
    login() {
      this.axios
        .post(`${this.$API}/auth/local`, {
          identifier: this.email,
          password: this.password
        })
        .then(response => {
          let payload = {
            token: response.data.jwt,
            user: response.data.user
          };
          this.$store.commit("login", payload);
          this.$router.push("dashboard");
        })
        .catch(error => {
          alert("Incorrect email or password");
          console.log(error);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
input {
  margin-bottom: 10px;
  width: 400px;
}
.box {
  width: 500px;
}
.error {
  color: $red;
}
</style>
